import { useEffect, useState } from "react"
import { Step } from "../../components/Step/ResultsStep"
import { content, generate } from "../../services/resultsService";
import { Field, Formik, Form } from "formik";
import { Oval } from "react-loader-spinner";
import * as Yup from "yup";
import { NextButtonBlack } from "../../components/Buttons/NextButtonBlack";

export const ResultsContent = () => {
    const [hasPaid, setHasPaid] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [contentCalendar, setContentCalendar] = useState([
        {
            date: 'January 1',
            post_idea: 'Sample Post Idea',
            caption: 'Sample Caption'
        }
    ]);

    const [companyName, setCompanyName] = useState("Your Company");

    const initialValues = {
        month: ''
    }

    const header = {
        index: "10",
        section: "Content",
        company: companyName
    }

    const _handleSubmit = (values) => {
        setIsLoading(true);
        generate(values).then(response => {
            setIsLoading(false);
            const { calendar } = response.data;
            const data = JSON.parse(calendar).calendar;
            if (data) {
                setContentCalendar(data)
            }
        }).catch(err => {
            const status = err.response.status;
            setIsLoading(false);
            if (status === 403) {
                setHasPaid(false);
            }
        })
    }

    const handleClick = () => {
        window.location.href = "/flow/checkout"
    }

    const ContentSchema = Yup.object().shape({
        month: Yup.string()
            .matches(/^(January|February|March|April|May|June|July|August|September|October|November|December) \d{4}$/,
                { message: "Value must be the same format as the placeholder." })
            .required("Please insert a value.")
    });

    useEffect(() => {
        content().then(response => {
            const { company, calendar } = response.data;
            const data = JSON.parse(calendar).calendar;
            if (data) {
                setHasPaid(true);
                setContentCalendar(data)
            }
            company ? setCompanyName(company) : setCompanyName('Your Company');
        }).catch(err => {
            console.error(err);
        })
    }, []);

    return (
        <Step header={header}>
            {hasPaid ? (
                <>
                    <table>
                        <thead>
                            <tr>
                                <td className="date">Date</td>
                                <td className="post">Post Idea</td>
                                <td className="caption">Caption</td>
                            </tr>
                        </thead>
                        <tbody>
                            {contentCalendar.map((el, index) => (
                                <tr key={index}>
                                    <td className="date">{el.date}</td>
                                    <td className="post">{el.post_idea}</td>
                                    <td className="caption">{el.caption}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={_handleSubmit}
                        enableReinitialize
                        validationSchema={ContentSchema}
                    >
                        {({ errors, touched }) => (
                            <Form className="flex items-center gap-8">
                                <label className="text-lg">Generate New Content For:</label>
                                <Field
                                    name="month"
                                    className="has-border-bottom max-w-fit"
                                    autoComplete="off"
                                    placeholder="June 2025" />
                                {errors.month && touched.month ? (
                                    <p className="required has-red-text">{errors.month}</p>
                                ) : null}
                                <button className="btn yellow-cta" type="submit">
                                    {isLoading ? (
                                        <Oval
                                            height={30}
                                            width={50}
                                            color="black"
                                            secondaryColor="black"
                                        />
                                    ) : (
                                        <span className="text-black">
                                            Generate
                                        </span>
                                    )}
                                </button>
                            </Form>
                        )}
                    </Formik>
                </>
            ) : (
                <>
                    <table>
                        <thead>
                            <tr>
                                <td className="date">Date</td>
                                <td className="post">Post Idea</td>
                                <td className="caption">Caption</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="date statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Date</td>
                                <td className="post statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Post Idea</td>
                                <td className="caption statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Caption</td>
                            </tr>
                            <tr>
                                <td className="date statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Date</td>
                                <td className="post statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Post Idea</td>
                                <td className="caption statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Caption</td>
                            </tr>
                            <tr>
                                <td className="date statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Date</td>
                                <td className="post statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Post Idea</td>
                                <td className="caption statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Caption</td>
                            </tr>
                            <tr>
                                <td className="date statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Date</td>
                                <td className="post statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Post Idea</td>
                                <td className="caption statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Caption</td>
                            </tr>
                            <tr>
                                <td className="date statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Date</td>
                                <td className="post statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Post Idea</td>
                                <td className="caption statement__paidText" style={{ textShadow: "0px 0px 30px rgb(255 255 255)", color: "transparent" }}>Caption</td>
                            </tr>

                        </tbody>
                    </table>
                    {!isLoading && (
                        <div className="flex gap-8 items-center">
                            <p className="results__description" style={{ width: 'max-content' }}>
                                Please complete payment in order to view this content.
                            </p>
                            <button className="btn prev" onClick={handleClick}>
                                <NextButtonBlack isYellow />
                            </button>
                        </div>
                    )}
                </>
            )}
        </Step>
    )
}